import { ActionButtonProps } from "./Buttons.types";
import { ButtonTT } from "./Button";
import { getProps } from "@components-system";
import { IAction } from "../../packages/web/components-types/src";
import { useDispatcher } from "../../hooks";
import { withRootie } from "../../components-system/core/withRootie";
import { useNavigate } from "react-router-dom";
import { useModal } from "@components-common/modals";
import { OverlayTooltip } from "../../components-domain/generation-domain/specifications/OverlayTooltip";
import Tooltip from "react-bootstrap/Tooltip";

export const ActionButtonInner = ({
  kind,
  action = kind as any,
  id = action,
  actionToDispatch,
  data,
  mapper: mapperParam,
  onAction,
  as: Component = ButtonTT,

  ...rest
}: ActionButtonProps) => {
  const mapper = mapperParam
    ? mapperParam
    : (data: any) =>
        actionToDispatch || { action: action || kind, payload: data };
  const handleClick = () => {
    const mapperDate = mapper(data);
    if (onAction) {
      onAction(mapperDate);
      return;
    } else {
      mapper(data);
      return;
    }
  };
  return (
    <Component
      data={mapper(data)}
      {...({ action, kind, ...rest } as any)}
      onClick={() => handleClick!()}
      key={id}
    />
  );
};

const ActionButton1 = (props: ActionButtonProps) => {
  const nav = useNavigate();
  const { showModal } = useModal();
  const [dispatch] = useDispatcher();
  const { displayTooltip, tooltipText } = props;

  const onActionDispatch = (action: IAction) => {
    if (props.onAction) {
      props.onAction({ ...action, navigate: nav });
    } else if (action.action === "create_new") {
      nav(action.payload.path);
    } else if (action.action === "open_modal") {
      showModal(action.payload);
    } else {
      (dispatch(action) as any).catch((x: any) =>
        console.log("ActionButton.tsx: onActionDispatch", x)
      );
    }
  };
  const newProps = getProps(props);
  return (
    <>
      <OverlayTooltip
        data={{ tooltipText }}
        component={DynamicTooltip}
        trigger={displayTooltip ? ["hover", "focus"] : []}
      >
        <ActionButtonInner
          {...newProps}
          onAction={(action: any) => onActionDispatch(action)}
        />
      </OverlayTooltip>
    </>
  );
};

export const ActionButton = withRootie(ActionButton1, {
  category: "button",
  useDefaults: true,
});

const DynamicTooltip = ({ tooltipText }: any) => (
  <Tooltip className="tooltip-button" style={{ position: "fixed" }}>
    {tooltipText}
  </Tooltip>
);
